import React, { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const DEST_LIST = ["Dubai", "Singapore", "Thailand", "Bali", "Vietnam", "Maldives", "Mauritius", "Europe", "Australia", "Andaman", "Kashmir", "Goa", "Kerala", "Himachal", "Uttarakhand", "Bhutan", "Nepal", "Other"];

export default function LeadForm({ compact = false, defaultDestination = "", title = "Get a Free Custom Quote", source = "website" }) {
  const [f, setF] = useState({ name: "", phone: "", whatsapp: "", email: "", destination: defaultDestination, travel_date: "", travelers: "2", budget: "", message: "" });
  const [loading, setLoading] = useState(false);

  const onChange = (e) => setF({ ...f, [e.target.name]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (!f.name || !f.phone) { toast.error("Please share your name and phone"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/leads", { ...f, source });
      toast.success(data.message || "Thanks! We'll be in touch shortly.");
      setF({ name: "", phone: "", whatsapp: "", email: "", destination: defaultDestination, travel_date: "", travelers: "2", budget: "", message: "" });
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally { setLoading(false); }
  };

  const inputCls = "w-full px-4 py-3 rounded-xl border border-slate-200 bg-white focus:outline-none focus:border-[#006CE4] focus:ring-4 focus:ring-blue-100 text-sm transition";

  return (
    <form onSubmit={submit} className="w-full" data-testid="lead-form">
      {!compact && <h3 className="h3 mb-2">{title}</h3>}
      {!compact && <p className="muted text-sm mb-6">Our travel expert will call you back within 30 minutes.</p>}
      <div className={`grid gap-4 ${compact ? "grid-cols-1" : "grid-cols-1 sm:grid-cols-2"}`}>
        <input required name="name" placeholder="Full Name*" value={f.name} onChange={onChange} className={inputCls} data-testid="lead-name" />
        <input required name="phone" placeholder="Phone Number*" value={f.phone} onChange={onChange} className={inputCls} data-testid="lead-phone" />
        <input name="whatsapp" placeholder="WhatsApp Number" value={f.whatsapp} onChange={onChange} className={inputCls} data-testid="lead-whatsapp" />
        <input name="email" type="email" placeholder="Email" value={f.email} onChange={onChange} className={inputCls} data-testid="lead-email" />
        <select name="destination" value={f.destination} onChange={onChange} className={inputCls} data-testid="lead-destination">
          <option value="">Select Destination</option>
          {DEST_LIST.map(d => <option key={d} value={d}>{d}</option>)}
        </select>
        <input name="travel_date" type="date" value={f.travel_date} onChange={onChange} className={inputCls} data-testid="lead-date" />
        <input name="travelers" type="number" min="1" placeholder="Travelers" value={f.travelers} onChange={onChange} className={inputCls} data-testid="lead-travelers" />
        <select name="budget" value={f.budget} onChange={onChange} className={inputCls} data-testid="lead-budget">
          <option value="">Budget (per person)</option>
          <option>Under ₹25,000</option>
          <option>₹25,000 - ₹50,000</option>
          <option>₹50,000 - ₹1,00,000</option>
          <option>₹1,00,000+</option>
        </select>
      </div>
      <textarea name="message" placeholder="Anything specific? Preferred hotel, activities, etc." rows="3" value={f.message} onChange={onChange} className={`${inputCls} mt-4 resize-none`} data-testid="lead-message" />
      <button type="submit" disabled={loading} className="btn-primary mt-5 w-full sm:w-auto disabled:opacity-60" data-testid="lead-submit">
        {loading ? <><Loader2 className="w-4 h-4 animate-spin mr-2" /> Sending...</> : "Get Free Quote"}
      </button>
    </form>
  );
}
